// extracted by mini-css-extract-plugin
module.exports = {"header":"CreateBoard_header__1MK48","createBoard":"CreateBoard_createBoard__2LI3S","boardInput":"CreateBoard_boardInput__14GSp","inputElement":"CreateBoard_inputElement__3EttR"};